import SideNavGroup from '@/components/side-nav/SideNavGroup'
import SideNavItem from '@/components/side-nav/SideNavItem'

export default {
  name: 'SideNav',
  template: '#side-nav-template',
  data () {
    return {
      siteSection: ''
    }
  },
  components: {SideNavGroup, SideNavItem},
  computed: {
    sideNavLinks () {
      if (this.$route.path.includes('create') || this.$route.name === 'createteam' || this.$route.name === 'createtickets') {
        this.siteSection = 'create'
      } else if (this.$route.path.includes('compete')) {
        this.siteSection = 'compete'
      } else if (this.$route.path.includes('triumph')) {
        this.siteSection = 'triumph'
      }
      return this.siteSection
    },
    disableTickets () {
      return false // window.clash2018.region === 'zh'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/side-nav/SideNav.js